import type { EnumDef } from '@mss_creator/shared';
import { FlagRow } from './flag-row';
import { useFlagMutation } from './use-flag-mutation';

interface StandardFlagRowProps {
  def: EnumDef;
  /** The value the server holds. */
  serverValue: string;
}

/** A flag written straight to the backend on click (the two Claude model flags). */
export function StandardFlagRow({ def, serverValue }: StandardFlagRowProps) {
  const { mutation, saved } = useFlagMutation(def.key);
  const previousLabel = def.options.find((option) => option.value === serverValue)?.label;
  const errorMessage = mutation.isError
    ? `L'enregistrement a échoué : la valeur précédente (${previousLabel ?? serverValue}) est rétablie. Réessayez dans un instant.`
    : undefined;

  return (
    <FlagRow
      def={def}
      value={mutation.isPending ? (mutation.variables ?? serverValue) : serverValue}
      pending={mutation.isPending}
      saved={saved}
      errorMessage={errorMessage}
      onSelect={(next) => {
        if (next !== serverValue) mutation.mutate(next);
      }}
    />
  );
}
